/* eslint-disable @typescript-eslint/naming-convention */ export var Sprites = /*#__PURE__*/ function(Sprites) {
    Sprites["tile_fog"] = "tile_fog";
    Sprites["tile_lumber_empty"] = "tile_lumber_empty";
    Sprites["tile_brick_empty"] = "tile_brick_empty";
    Sprites["tile_wool_empty"] = "tile_wool_empty";
    Sprites["tile_grain_empty"] = "tile_grain_empty";
    Sprites["tile_ore_empty"] = "tile_ore_empty";
    Sprites["tile_desert_empty"] = "tile_desert_empty";
    Sprites["tile_gold_empty"] = "tile_gold_empty";
    Sprites["tile_lumber_side"] = "tile_lumber_side";
    Sprites["tile_brick_side"] = "tile_brick_side";
    Sprites["tile_wool_side"] = "tile_wool_side";
    Sprites["tile_grain_side"] = "tile_grain_side";
    Sprites["tile_ore_side"] = "tile_ore_side";
    Sprites["tile_desert_side"] = "tile_desert_side";
    Sprites["tile_gold_side"] = "tile_gold_side";
    Sprites["ship_red_north_west"] = "ship_red_north_west";
    Sprites["ship_red_west"] = "ship_red_west";
    Sprites["ship_red_south_west"] = "ship_red_south_west";
    Sprites["ship_black_north_west"] = "ship_black_north_west";
    Sprites["ship_black_west"] = "ship_black_west";
    Sprites["ship_black_south_west"] = "ship_black_south_west";
    Sprites["ship_blue_north_west"] = "ship_blue_north_west";
    Sprites["ship_blue_west"] = "ship_blue_west";
    Sprites["ship_blue_south_west"] = "ship_blue_south_west";
    Sprites["ship_bronze_north_west"] = "ship_bronze_north_west";
    Sprites["ship_bronze_west"] = "ship_bronze_west";
    Sprites["ship_bronze_south_west"] = "ship_bronze_south_west";
    Sprites["ship_gold_north_west"] = "ship_gold_north_west";
    Sprites["ship_gold_west"] = "ship_gold_west";
    Sprites["ship_gold_south_west"] = "ship_gold_south_west";
    Sprites["ship_green_north_west"] = "ship_green_north_west";
    Sprites["ship_green_west"] = "ship_green_west";
    Sprites["ship_green_south_west"] = "ship_green_south_west";
    Sprites["ship_mysticblue_north_west"] = "ship_mysticblue_north_west";
    Sprites["ship_mysticblue_west"] = "ship_mysticblue_west";
    Sprites["ship_mysticblue_south_west"] = "ship_mysticblue_south_west";
    Sprites["ship_orange_north_west"] = "ship_orange_north_west";
    Sprites["ship_orange_west"] = "ship_orange_west";
    Sprites["ship_orange_south_west"] = "ship_orange_south_west";
    Sprites["ship_purple_north_west"] = "ship_purple_north_west";
    Sprites["ship_purple_west"] = "ship_purple_west";
    Sprites["ship_purple_south_west"] = "ship_purple_south_west";
    Sprites["ship_silver_north_west"] = "ship_silver_north_west";
    Sprites["ship_silver_west"] = "ship_silver_west";
    Sprites["ship_silver_south_west"] = "ship_silver_south_west";
    Sprites["ship_white_north_west"] = "ship_white_north_west";
    Sprites["ship_white_west"] = "ship_white_west";
    Sprites["ship_white_south_west"] = "ship_white_south_west";
    Sprites["ship_pink_north_west"] = "ship_pink_north_west";
    Sprites["ship_pink_west"] = "ship_pink_west";
    Sprites["ship_pink_south_west"] = "ship_pink_south_west";
    Sprites["ship_highlight_north_west"] = "ship_highlight_north_west";
    Sprites["ship_highlight_west"] = "ship_highlight_west";
    Sprites["ship_highlight_south_west"] = "ship_highlight_south_west";
    Sprites["ship_move_black"] = "ship_move_black";
    Sprites["ship_move_blue"] = "ship_move_blue";
    Sprites["ship_move_bronze"] = "ship_move_bronze";
    Sprites["ship_move_gold"] = "ship_move_gold";
    Sprites["ship_move_green"] = "ship_move_green";
    Sprites["ship_move_mysticblue"] = "ship_move_mysticblue";
    Sprites["ship_move_orange"] = "ship_move_orange";
    Sprites["ship_move_purple"] = "ship_move_purple";
    Sprites["ship_move_red"] = "ship_move_red";
    Sprites["ship_move_silver"] = "ship_move_silver";
    Sprites["ship_move_white"] = "ship_move_white";
    Sprites["ship_move_pink"] = "ship_move_pink";
    // All shore tiles start with TopRight as the first location of shore
    Sprites["tile_sea"] = "tile_sea";
    Sprites["tile_shore_1"] = "tile_shore_1";
    Sprites["tile_shore_2_sswwww"] = "tile_shore_2_sswwww";
    Sprites["tile_shore_2_swswww"] = "tile_shore_2_swswww";
    Sprites["tile_shore_2_swwsww"] = "tile_shore_2_swwsww";
    Sprites["tile_shore_3_ssswww"] = "tile_shore_3_ssswww";
    Sprites["tile_shore_3_sswwsw"] = "tile_shore_3_sswwsw";
    Sprites["tile_shore_3_sswsww"] = "tile_shore_3_sswsww";
    Sprites["tile_shore_3_swswsw"] = "tile_shore_3_swswsw";
    Sprites["tile_shore_4_ssssww"] = "tile_shore_4_ssssww";
    Sprites["tile_shore_4_ssswsw"] = "tile_shore_4_ssswsw";
    Sprites["tile_shore_4_sswssw"] = "tile_shore_4_sswssw";
    Sprites["tile_shore_5"] = "tile_shore_5";
    Sprites["tile_shore_6"] = "tile_shore_6";
    Sprites["prob_2"] = "prob_2";
    Sprites["prob_3"] = "prob_3";
    Sprites["prob_4"] = "prob_4";
    Sprites["prob_5"] = "prob_5";
    Sprites["prob_6"] = "prob_6";
    Sprites["prob_8"] = "prob_8";
    Sprites["prob_9"] = "prob_9";
    Sprites["prob_10"] = "prob_10";
    Sprites["prob_11"] = "prob_11";
    Sprites["prob_12"] = "prob_12";
    Sprites["icon_colonist_coin"] = "icon_colonist_coin";
    Sprites["icon_robber"] = "icon_robber";
    Sprites["icon_robber_santa"] = "icon_robber_santa";
    Sprites["icon_robber_lunar"] = "icon_robber_lunar";
    Sprites["icon_robber_cupid"] = "icon_robber_cupid";
    Sprites["icon_robber_tie"] = "icon_robber_tie";
    Sprites["icon_hourglass"] = "icon_hourglass";
    Sprites["icon_bot"] = "icon_bot";
    Sprites["icon_pencil"] = "icon_pencil";
    Sprites["icon_players"] = "icon_players";
    Sprites["icon_trade_bank_check"] = "icon_trade_bank_check";
    Sprites["icon_trade_opponents_check"] = "icon_trade_opponents_check";
    Sprites["icon_merchant_black"] = "icon_merchant_black";
    Sprites["icon_merchant_blue"] = "icon_merchant_blue";
    Sprites["icon_merchant_bronze"] = "icon_merchant_bronze";
    Sprites["icon_merchant_gold"] = "icon_merchant_gold";
    Sprites["icon_merchant_green"] = "icon_merchant_green";
    Sprites["icon_merchant_mysticblue"] = "icon_merchant_mysticblue";
    Sprites["icon_merchant_orange"] = "icon_merchant_orange";
    Sprites["icon_merchant_purple"] = "icon_merchant_purple";
    Sprites["icon_merchant_red"] = "icon_merchant_red";
    Sprites["icon_merchant_silver"] = "icon_merchant_silver";
    Sprites["icon_merchant_white"] = "icon_merchant_white";
    Sprites["icon_merchant_pink"] = "icon_merchant_pink";
    Sprites["city_white"] = "city_white";
    Sprites["city_blue"] = "city_blue";
    Sprites["city_red"] = "city_red";
    Sprites["city_orange"] = "city_orange";
    Sprites["city_green"] = "city_green";
    Sprites["city_gold"] = "city_gold";
    Sprites["city_silver"] = "city_silver";
    Sprites["city_bronze"] = "city_bronze";
    Sprites["city_purple"] = "city_purple";
    Sprites["city_black"] = "city_black";
    Sprites["city_mysticblue"] = "city_mysticblue";
    Sprites["city_pink"] = "city_pink";
    Sprites["city_destroyed_white"] = "city_destroyed_white";
    Sprites["city_destroyed_blue"] = "city_destroyed_blue";
    Sprites["city_destroyed_red"] = "city_destroyed_red";
    Sprites["city_destroyed_orange"] = "city_destroyed_orange";
    Sprites["city_destroyed_green"] = "city_destroyed_green";
    Sprites["city_destroyed_gold"] = "city_destroyed_gold";
    Sprites["city_destroyed_silver"] = "city_destroyed_silver";
    Sprites["city_destroyed_bronze"] = "city_destroyed_bronze";
    Sprites["city_destroyed_purple"] = "city_destroyed_purple";
    Sprites["city_destroyed_black"] = "city_destroyed_black";
    Sprites["city_destroyed_mysticblue"] = "city_destroyed_mysticblue";
    Sprites["city_destroyed_pink"] = "city_destroyed_pink";
    Sprites["city_wall_white"] = "city_wall_white";
    Sprites["city_wall_blue"] = "city_wall_blue";
    Sprites["city_wall_red"] = "city_wall_red";
    Sprites["city_wall_orange"] = "city_wall_orange";
    Sprites["city_wall_green"] = "city_wall_green";
    Sprites["city_wall_gold"] = "city_wall_gold";
    Sprites["city_wall_silver"] = "city_wall_silver";
    Sprites["city_wall_bronze"] = "city_wall_bronze";
    Sprites["city_wall_purple"] = "city_wall_purple";
    Sprites["city_wall_black"] = "city_wall_black";
    Sprites["city_wall_mysticblue"] = "city_wall_mysticblue";
    Sprites["city_wall_pink"] = "city_wall_pink";
    Sprites["road_white"] = "road_white";
    Sprites["road_blue"] = "road_blue";
    Sprites["road_red"] = "road_red";
    Sprites["road_orange"] = "road_orange";
    Sprites["road_green"] = "road_green";
    Sprites["road_gold"] = "road_gold";
    Sprites["road_silver"] = "road_silver";
    Sprites["road_bronze"] = "road_bronze";
    Sprites["road_purple"] = "road_purple";
    Sprites["road_black"] = "road_black";
    Sprites["road_mysticblue"] = "road_mysticblue";
    Sprites["road_pink"] = "road_pink";
    Sprites["road_highlight"] = "road_highlight";
    Sprites["settlement_white"] = "settlement_white";
    Sprites["settlement_blue"] = "settlement_blue";
    Sprites["settlement_red"] = "settlement_red";
    Sprites["settlement_orange"] = "settlement_orange";
    Sprites["settlement_green"] = "settlement_green";
    Sprites["settlement_gold"] = "settlement_gold";
    Sprites["settlement_silver"] = "settlement_silver";
    Sprites["settlement_bronze"] = "settlement_bronze";
    Sprites["settlement_purple"] = "settlement_purple";
    Sprites["settlement_black"] = "settlement_black";
    Sprites["settlement_mysticblue"] = "settlement_mysticblue";
    Sprites["settlement_pink"] = "settlement_pink";
    Sprites["knight_level1_active_black"] = "knight_level1_active_black";
    Sprites["knight_level1_active_blue"] = "knight_level1_active_blue";
    Sprites["knight_level1_active_bronze"] = "knight_level1_active_bronze";
    Sprites["knight_level1_active_gold"] = "knight_level1_active_gold";
    Sprites["knight_level1_active_green"] = "knight_level1_active_green";
    Sprites["knight_level1_active_mysticblue"] = "knight_level1_active_mysticblue";
    Sprites["knight_level1_active_orange"] = "knight_level1_active_orange";
    Sprites["knight_level1_active_purple"] = "knight_level1_active_purple";
    Sprites["knight_level1_active_red"] = "knight_level1_active_red";
    Sprites["knight_level1_active_silver"] = "knight_level1_active_silver";
    Sprites["knight_level1_active_white"] = "knight_level1_active_white";
    Sprites["knight_level1_active_pink"] = "knight_level1_active_pink";
    Sprites["knight_level2_active_black"] = "knight_level2_active_black";
    Sprites["knight_level2_active_blue"] = "knight_level2_active_blue";
    Sprites["knight_level2_active_bronze"] = "knight_level2_active_bronze";
    Sprites["knight_level2_active_gold"] = "knight_level2_active_gold";
    Sprites["knight_level2_active_green"] = "knight_level2_active_green";
    Sprites["knight_level2_active_mysticblue"] = "knight_level2_active_mysticblue";
    Sprites["knight_level2_active_orange"] = "knight_level2_active_orange";
    Sprites["knight_level2_active_purple"] = "knight_level2_active_purple";
    Sprites["knight_level2_active_red"] = "knight_level2_active_red";
    Sprites["knight_level2_active_silver"] = "knight_level2_active_silver";
    Sprites["knight_level2_active_white"] = "knight_level2_active_white";
    Sprites["knight_level2_active_pink"] = "knight_level2_active_pink";
    Sprites["knight_level3_active_black"] = "knight_level3_active_black";
    Sprites["knight_level3_active_blue"] = "knight_level3_active_blue";
    Sprites["knight_level3_active_bronze"] = "knight_level3_active_bronze";
    Sprites["knight_level3_active_gold"] = "knight_level3_active_gold";
    Sprites["knight_level3_active_green"] = "knight_level3_active_green";
    Sprites["knight_level3_active_mysticblue"] = "knight_level3_active_mysticblue";
    Sprites["knight_level3_active_orange"] = "knight_level3_active_orange";
    Sprites["knight_level3_active_purple"] = "knight_level3_active_purple";
    Sprites["knight_level3_active_red"] = "knight_level3_active_red";
    Sprites["knight_level3_active_silver"] = "knight_level3_active_silver";
    Sprites["knight_level3_active_white"] = "knight_level3_active_white";
    Sprites["knight_level3_active_pink"] = "knight_level3_active_pink";
    Sprites["knight_level1_inactive_black"] = "knight_level1_inactive_black";
    Sprites["knight_level1_inactive_blue"] = "knight_level1_inactive_blue";
    Sprites["knight_level1_inactive_bronze"] = "knight_level1_inactive_bronze";
    Sprites["knight_level1_inactive_gold"] = "knight_level1_inactive_gold";
    Sprites["knight_level1_inactive_green"] = "knight_level1_inactive_green";
    Sprites["knight_level1_inactive_mysticblue"] = "knight_level1_inactive_mysticblue";
    Sprites["knight_level1_inactive_orange"] = "knight_level1_inactive_orange";
    Sprites["knight_level1_inactive_purple"] = "knight_level1_inactive_purple";
    Sprites["knight_level1_inactive_red"] = "knight_level1_inactive_red";
    Sprites["knight_level1_inactive_silver"] = "knight_level1_inactive_silver";
    Sprites["knight_level1_inactive_white"] = "knight_level1_inactive_white";
    Sprites["knight_level1_inactive_pink"] = "knight_level1_inactive_pink";
    Sprites["knight_level2_inactive_black"] = "knight_level2_inactive_black";
    Sprites["knight_level2_inactive_blue"] = "knight_level2_inactive_blue";
    Sprites["knight_level2_inactive_bronze"] = "knight_level2_inactive_bronze";
    Sprites["knight_level2_inactive_gold"] = "knight_level2_inactive_gold";
    Sprites["knight_level2_inactive_green"] = "knight_level2_inactive_green";
    Sprites["knight_level2_inactive_mysticblue"] = "knight_level2_inactive_mysticblue";
    Sprites["knight_level2_inactive_orange"] = "knight_level2_inactive_orange";
    Sprites["knight_level2_inactive_purple"] = "knight_level2_inactive_purple";
    Sprites["knight_level2_inactive_red"] = "knight_level2_inactive_red";
    Sprites["knight_level2_inactive_silver"] = "knight_level2_inactive_silver";
    Sprites["knight_level2_inactive_white"] = "knight_level2_inactive_white";
    Sprites["knight_level2_inactive_pink"] = "knight_level2_inactive_pink";
    Sprites["knight_level3_inactive_black"] = "knight_level3_inactive_black";
    Sprites["knight_level3_inactive_blue"] = "knight_level3_inactive_blue";
    Sprites["knight_level3_inactive_bronze"] = "knight_level3_inactive_bronze";
    Sprites["knight_level3_inactive_gold"] = "knight_level3_inactive_gold";
    Sprites["knight_level3_inactive_green"] = "knight_level3_inactive_green";
    Sprites["knight_level3_inactive_mysticblue"] = "knight_level3_inactive_mysticblue";
    Sprites["knight_level3_inactive_orange"] = "knight_level3_inactive_orange";
    Sprites["knight_level3_inactive_purple"] = "knight_level3_inactive_purple";
    Sprites["knight_level3_inactive_red"] = "knight_level3_inactive_red";
    Sprites["knight_level3_inactive_silver"] = "knight_level3_inactive_silver";
    Sprites["knight_level3_inactive_white"] = "knight_level3_inactive_white";
    Sprites["knight_level3_inactive_pink"] = "knight_level3_inactive_pink";
    Sprites["knight_move_black"] = "knight_move_black";
    Sprites["knight_move_blue"] = "knight_move_blue";
    Sprites["knight_move_bronze"] = "knight_move_bronze";
    Sprites["knight_move_gold"] = "knight_move_gold";
    Sprites["knight_move_green"] = "knight_move_green";
    Sprites["knight_move_mysticblue"] = "knight_move_mysticblue";
    Sprites["knight_move_orange"] = "knight_move_orange";
    Sprites["knight_move_purple"] = "knight_move_purple";
    Sprites["knight_move_red"] = "knight_move_red";
    Sprites["knight_move_silver"] = "knight_move_silver";
    Sprites["knight_move_white"] = "knight_move_white";
    Sprites["knight_move_pink"] = "knight_move_pink";
    Sprites["knight_active_level1"] = "knight_active_level1";
    Sprites["metropolis_science"] = "metropolis_science";
    Sprites["metropolis_trade"] = "metropolis_trade";
    Sprites["metropolis_politics"] = "metropolis_politics";
    Sprites["port_pier"] = "port_pier";
    Sprites["port"] = "port";
    Sprites["port_lumber"] = "port_lumber";
    Sprites["port_brick"] = "port_brick";
    Sprites["port_wool"] = "port_wool";
    Sprites["port_grain"] = "port_grain";
    Sprites["port_ore"] = "port_ore";
    Sprites["port_highlight"] = "port_highlight";
    Sprites["card_lumber"] = "card_lumber";
    Sprites["card_brick"] = "card_brick";
    Sprites["card_wool"] = "card_wool";
    Sprites["card_grain"] = "card_grain";
    Sprites["card_ore"] = "card_ore";
    Sprites["card_vp"] = "card_vp";
    Sprites["card_knight"] = "card_knight";
    Sprites["card_yearofplenty"] = "card_yearofplenty";
    Sprites["card_monopoly"] = "card_monopoly";
    Sprites["card_roadbuilding"] = "card_roadbuilding";
    Sprites["card_badge_background"] = "card_badge_background";
    Sprites["card_paper"] = "card_paper";
    Sprites["card_cloth"] = "card_cloth";
    Sprites["card_coin"] = "card_coin";
    Sprites["card_overlay_blue"] = "card_overlay_blue";
    Sprites["card_overlay_black"] = "card_overlay_black";
    Sprites["card_overlay_white"] = "card_overlay_white";
    Sprites["card_progress_politics_back"] = "card_progress_politics_back";
    Sprites["card_progress_politics_bishop"] = "card_progress_politics_bishop";
    Sprites["card_progress_politics_constitution"] = "card_progress_politics_constitution";
    Sprites["card_progress_politics_deserter"] = "card_progress_politics_deserter";
    Sprites["card_progress_politics_diplomat"] = "card_progress_politics_diplomat";
    Sprites["card_progress_politics_intrigue"] = "card_progress_politics_intrigue";
    Sprites["card_progress_politics_saboteur"] = "card_progress_politics_saboteur";
    Sprites["card_progress_politics_spy"] = "card_progress_politics_spy";
    Sprites["card_progress_politics_warlord"] = "card_progress_politics_warlord";
    Sprites["card_progress_politics_wedding"] = "card_progress_politics_wedding";
    Sprites["card_progress_science_back"] = "card_progress_science_back";
    Sprites["card_progress_science_alchemist"] = "card_progress_science_alchemist";
    Sprites["card_progress_science_crane"] = "card_progress_science_crane";
    Sprites["card_progress_science_engineer"] = "card_progress_science_engineer";
    Sprites["card_progress_science_inventor"] = "card_progress_science_inventor";
    Sprites["card_progress_science_irrigation"] = "card_progress_science_irrigation";
    Sprites["card_progress_science_medicine"] = "card_progress_science_medicine";
    Sprites["card_progress_science_mining"] = "card_progress_science_mining";
    Sprites["card_progress_science_printer"] = "card_progress_science_printer";
    Sprites["card_progress_science_road_building"] = "card_progress_science_road_building";
    Sprites["card_progress_science_smith"] = "card_progress_science_smith";
    Sprites["card_progress_trade_back"] = "card_progress_trade_back";
    Sprites["card_progress_trade_commercial_harbor"] = "card_progress_trade_commercial_harbor";
    Sprites["card_progress_trade_master_merchant"] = "card_progress_trade_master_merchant";
    Sprites["card_progress_trade_merchant_fleet"] = "card_progress_trade_merchant_fleet";
    Sprites["card_progress_trade_merchant"] = "card_progress_trade_merchant";
    Sprites["card_progress_trade_resource_monopoly"] = "card_progress_trade_resource_monopoly";
    Sprites["card_progress_trade_commodity_monopoly"] = "card_progress_trade_commodity_monopoly";
    Sprites["icon_player"] = "icon_player";
    Sprites["icon_player_loggedin"] = "icon_player_loggedin";
    Sprites["icon_settler"] = "icon_settler";
    Sprites["icon_colonist"] = "icon_colonist";
    Sprites["icon_founder"] = "icon_founder";
    Sprites["icon_christmas_hat"] = "icon_christmas_hat";
    Sprites["icon_pirate_ship"] = "icon_pirate_ship";
    Sprites["icon_discard_resource_cards"] = "icon_discard_resource_cards";
    Sprites["icon_discard_progress_cards"] = "icon_discard_progress_cards";
    Sprites["icon_aqueduct"] = "icon_aqueduct";
    Sprites["icon_fortress"] = "icon_fortress";
    Sprites["icon_tradehouse"] = "icon_tradehouse";
    Sprites["icon_lock_on"] = "icon_lock_on";
    Sprites["icon_lock_off"] = "icon_lock_off";
    Sprites["icon_trade_arrow_red"] = "icon_trade_arrow_red";
    Sprites["icon_trade_arrow_green"] = "icon_trade_arrow_green";
    Sprites["icon_trophy"] = "icon_trophy";
    Sprites["icon_chit"] = "icon_chit";
    Sprites["icon_check"] = "icon_check";
    Sprites["icon_x"] = "icon_x";
    Sprites["icon_trade"] = "icon_trade";
    Sprites["card_devcardback"] = "card_devcardback";
    Sprites["icon_pass_turn"] = "icon_pass_turn";
    Sprites["icon_highlight_circle"] = "icon_highlight_circle";
    Sprites["icon_highlight_circle_white"] = "icon_highlight_circle_white";
    Sprites["icon_highlight_square_yellow"] = "icon_highlight_square_yellow";
    Sprites["icon_arrow_player_profile"] = "icon_arrow_player_profile";
    Sprites["icon_arrow_player_profile_white"] = "icon_arrow_player_profile_white";
    Sprites["icon_beginner_hint"] = "icon_beginner_hint";
    Sprites["player_bg_black"] = "player_bg_black";
    Sprites["player_bg_blue"] = "player_bg_blue";
    Sprites["player_bg_bronze"] = "player_bg_bronze";
    Sprites["player_bg_gold"] = "player_bg_gold";
    Sprites["player_bg_green"] = "player_bg_green";
    Sprites["player_bg_orange"] = "player_bg_orange";
    Sprites["player_bg_purple"] = "player_bg_purple";
    Sprites["player_bg_red"] = "player_bg_red";
    Sprites["player_bg_silver"] = "player_bg_silver";
    Sprites["player_bg_mysticblue"] = "player_bg_mysticblue";
    Sprites["player_bg_white"] = "player_bg_white";
    Sprites["player_bg_pink"] = "player_bg_pink";
    Sprites["bg_section"] = "bg_section";
    Sprites["bg_section_dark"] = "bg_section_dark";
    Sprites["bg_button"] = "bg_button";
    Sprites["button_badge_background_white"] = "button_badge_background_white";
    Sprites["button_badge_background_blue"] = "button_badge_background_blue";
    Sprites["button_badge_background_red"] = "button_badge_background_red";
    Sprites["button_badge_background_orange"] = "button_badge_background_orange";
    Sprites["button_badge_background_green"] = "button_badge_background_green";
    Sprites["button_badge_background_gold"] = "button_badge_background_gold";
    Sprites["button_badge_background_silver"] = "button_badge_background_silver";
    Sprites["button_badge_background_bronze"] = "button_badge_background_bronze";
    Sprites["button_badge_background_purple"] = "button_badge_background_purple";
    Sprites["button_badge_background_black"] = "button_badge_background_black";
    Sprites["button_badge_background_mysticblue"] = "button_badge_background_mysticblue";
    Sprites["button_badge_background_pink"] = "button_badge_background_pink";
    Sprites["ribbon_large"] = "ribbon_large";
    Sprites["ribbon_long"] = "ribbon_long";
    Sprites["icon_beginner_hint_initial_placement"] = "icon_beginner_hint_initial_placement";
    Sprites["icon_sheep"] = "icon_sheep";
    Sprites["empty"] = "";
    return Sprites;
}({});
